import React, { useEffect } from 'react';
import { Link } from '@gerdau/hefesto';

import { ProductGrid, RelatedProduct, ShowMore } from './styles';
import ProductCard from '../../../../../components/Purchase/ProductCard';
import { useDispatch } from 'react-redux';
import { sendTagging } from '../../../../../store/ducks/tagging/actions';
import {
  IProductCardTagging,
  ITaggingParams
} from '../../../../../store/ducks/tagging/types';
import { IRelatedProducts } from '../../../../../services/ProductMvp/types';
import { SortProductsItem } from '../../../../../services/MVP/models';
import { EMeasureUnit } from '../../../../../store/commomTypes';
import { ProductInfoTitle } from '../styles';
import { useHistory } from 'react-router-dom';
import { EPurchaseRoutes } from '../../../purchase.routes';
import { EOrderSettingsRoutes } from '../../OrderSettingsMvp/orderSettings.routes';
import { ERoutes } from '../../../../../routes';

const PRODUCTINFO = {
  sku: '123',
  code: '109009787',
  destination: 'Distribuição',
  details: 'AR REC TORCIDO BWG16 1,65mm RL8kg',
  name: 'Arame Recozido',
  paymentDays: '21 dias',
  price: '8,00',
  priceUnity: 'unidade',
  secondaryPrice: '1,00',
  secondaryPriceUnity: 'KG',
  productUrl: '/nome-produto',
  productCategory: 'arames_industriais'
};

interface IParams {
  relatedProducts: IRelatedProducts;
  gpdValue: string;
}

export const RelatedProductSection = ({
  relatedProducts,
  gpdValue
}: IParams) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const productTaggingList: IProductCardTagging[] = [];
  const relatedProductsCards = relatedProducts.related.map(
    (productRelated, index) => {
      const product: SortProductsItem = {
        sku: productRelated.sku,
        name: productRelated.name,
        id: productRelated.id,
        attribute_set_id: productRelated.attribute_set_id,
        created_at: productRelated.created_at,
        updated_at: productRelated.updated_at,
        extension_attributes: productRelated.extension_attributes,
        custom_attributes: productRelated.custom_attributes.map(
          (attribute) => ({
            attribute_code: attribute.attribute_code,
            value: Array.isArray(attribute.value)
              ? attribute.value[0]
              : attribute.value
          })
        ),
        media_gallery_entries: productRelated.media_gallery_entries,
        options: productRelated.options,
        product_links: productRelated.product_links,
        type_id: productRelated.type_id,
        visibility: productRelated.visibility,
        status: productRelated.status,
        tier_prices: productRelated.tier_prices,
        price: {
          creditPrice: productRelated.price.creditPrice,
          destination: productRelated.price.destination,
          destinationDescription: productRelated.price.destinationDescription,
          isAgreementPrice: productRelated.price.isAgreementPrice,
          paymentTerms: productRelated.price.paymentTerms,
          paymentTermsDescription: productRelated.price.paymentTermsDescription,
          um: productRelated.price.um as EMeasureUnit,
          salesAgreementData: {
            agreementUm: productRelated.price.salesAgreementData.agreementUm,
            destination: productRelated.price.salesAgreementData.destination,
            expirationDate:
              productRelated.price.salesAgreementData.experition_date,
            paymentTerms: productRelated.price.salesAgreementData.paymentTerms,
            paymentTermsDescription:
              productRelated.price.salesAgreementData.paymentTermsDescription,
            salesAgreement: Number(
              productRelated.price.salesAgreementData.salesAgreement
            ),
            destinationDescription:
              productRelated.price.salesAgreementData.destinationDescription,
            um: productRelated.price.um
          }
        },
        salesDate: ''
      };
      const image =
        product.media_gallery_entries &&
        product.media_gallery_entries.length > 0
          ? {
              desktopSource: `${process.env.REACT_APP_MEDIA_BASE_URL}/media/catalog/product/${product.media_gallery_entries[0]?.file}`
            }
          : undefined;
      const descricao_gpm =
        product.custom_attributes.find(
          (att) => att.attribute_code === 'descricao_gpm'
        )?.value ?? '';

      productTaggingList.push({
        screenName: 'pagina_de_produto',
        price: `${product.price.creditPrice}`,
        unidade_de_medida: product.price.um,
        item_id: product.sku,
        item_name: product.name,
        tipo_compra: `vitrine`,
        item_category: descricao_gpm,
        cod_gerdau: product.id.toString(),
        preco_acordado: product.price.isAgreementPrice.length > 0,
        quantity: '1'
      });

      return (
        <ProductCard
          key={index}
          showLink={false}
          image={image}
          product={product}
        />
      );
    }
  );

  const navigateToCatalog = () => {
    history.push(
      `${ERoutes.PURCHASE}/${EOrderSettingsRoutes.LONG_STEEL}/${EPurchaseRoutes.COMMERCE}/${EOrderSettingsRoutes.CATALOG}?gpd=${gpdValue}`
    );
  };

  useEffect(() => {
    const viewItemListTagging: ITaggingParams = {
      event: 'view_item_list',
      screenName: 'pagina_de_produto',
      ecommerce: {
        screenName: 'pagina_de_produto',
        tipo_compra: 'vitrine',
        paginacao: '1',
        items: productTaggingList
      }
    };
    dispatch(sendTagging(viewItemListTagging));
  }, [relatedProductsCards]);

  return (
    <RelatedProduct>
      {relatedProducts.related.length > 0 && (
        <>
          <ProductInfoTitle>
            Outros produtos da mesma categoria
          </ProductInfoTitle>
          <ProductGrid>{relatedProductsCards}</ProductGrid>
          <ShowMore>
            <Link url="" name="Pesquisar mais" onClick={navigateToCatalog} />
          </ShowMore>
        </>
      )}
    </RelatedProduct>
  );
};
